document.addEventListener('DOMContentLoaded', function () {
    let marker = null;
    const mediumMapRadius = 50 * 1000;
    const defaultCenter = {lat: 59.33411852884427, lng: 18.069263380363168};
    const mapOptions = {
        zoom: 5,
        center: defaultCenter,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    let map = new google.maps.Map(document.getElementById('addressMap'), mapOptions);

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                map.setCenter(pos);
            }
        );
    }

    const searchInput = document.querySelector('#address-description');
    const addressInput = document.querySelector('#address');
    const options = {
        fields: ["formatted_address", "geometry"],
        origin: map.getCenter(),
        types: [],
        strictBounds: false
    };
    const autocomplete = new google.maps.places.Autocomplete(searchInput, options);
    autocomplete.bindTo("bounds", map);

    autocomplete.addListener("place_changed", function () {
        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
            return;
        }

        if (marker != null) {
            marker.setMap(null);
        }

        marker = new google.maps.Marker({
            position: place.geometry.location,
            map,
        });

        addressInput.value = place.geometry.location.lat() + ',' + place.geometry.location.lng();

        let radius = new google.maps.Circle(
            {
                radius: mediumMapRadius,
                center: place.geometry.location
            });

        map.fitBounds(radius.getBounds());
    });

    const inquiryForm = document.querySelector("#inquiryForm");

    inquiryForm.addEventListener('keydown', function (event){
        if (event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    const addressFields = document.querySelector('.builders__address-fields');
    const zipCodeFields = document.querySelector('.builders__zip-code-fields');
    const mapFields = document.querySelector('.builders__map-fields');
    const zipCodeInput = document.querySelector('#zip-code');
    const cityInput = document.querySelector('#city');
    const typeSelector = document.querySelector(".builders__address-type-selector");

    toggleAddressFields();
    typeSelector.addEventListener('change', toggleAddressFields);

    function toggleAddressFields() {
        if (typeSelector.value === 'address') {
            addressFields.style.display = 'block';
            mapFields.style.display = 'block';
            addressInput.disabled = false;

            zipCodeFields.style.display = 'none';
            zipCodeInput.disabled = true;
            cityInput.disabled = true;
        } else if (typeSelector.value === 'zip-code') {
            addressFields.style.display = 'none';
            mapFields.style.display = 'none';
            addressInput.disabled = true;

            zipCodeFields.style.display = 'block';
            zipCodeInput.disabled = false;
            cityInput.disabled = false;
        }
    }
});

function onSubmit(token) {
    if (!inquiryForm.checkValidity()) {
        inquiryForm.reportValidity();
    } else {
        document.querySelector('input[name=g-recaptcha-response]').value = token;
        inquiryForm.submit();
    }
}
